import Vue from 'vue'
import Router from 'vue-router'
import AuthGuard from '@/router/auth-guard'
import Home from '@/pages/Home'
import HelloWorld from '@/pages/HelloWorld'
import Historia from '@/pages/Historia'
import Encontro from '@/pages/Encontro'
import Galeria from '@/pages/Galeria'
import Arvore from '@/pages/Arvore'
import Signin from '@/pages/user/Signin'
import Signup from '@/pages/user/Signup'
import Usuarios from "@/pages/user/Usuarios";
import Params from "@/pages/user/Params";
import GaleriaParam from "@/pages/user/GaleriaParam";
import Contatos from "@/pages/user/Contatos";

Vue.use(Router)

export default new Router({
  //mode: "history",
  routes: [
    {
      path: '/home-admin',
      name: 'HelloWorld',
      component: HelloWorld,
      beforeEnter: AuthGuard
    },
    {
      path: '/historia',
      name: 'Historia',
      component: Historia,
      beforeEnter: AuthGuard
    },
    {
      path: '/arvore',
      name: 'Arvore',
      component: Arvore,
      beforeEnter: AuthGuard
    },
    {
      path: '/galeria',
      name: 'Galeria',
      component: Galeria,
      beforeEnter: AuthGuard
    },
    {
      path: '/encontro',
      name: 'Encontro',
      component: Encontro,
      beforeEnter: AuthGuard
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: AuthGuard
    },
    {
      path: "/admin/usuarios",
      name: "Usuarios",
      component: Usuarios,
      beforeEnter: AuthGuard
    },
    {
      path: "/admin/historia",
      name: "Params",
      component: Params,
      beforeEnter: AuthGuard
    },
    {
      path: "/admin/galeria",
      name: "GaleriaParam",
      component: GaleriaParam,
      beforeEnter: AuthGuard
    },
    {
      path: "/admin/contato",
      name: "Contatos",
      component: Contatos,
      beforeEnter: AuthGuard
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      beforeEnter: AuthGuard
    },
    {
      path: '/logout',
      name: 'Logout',
      beforeEnter: AuthGuard
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js